import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COUNTRIES, getCountry } from '../../services/country';

const MARKET_CITIES={
  DO:['Santo Domingo','Santiago','La Vega','Puerto Plata'],
  PA:['Ciudad de Panamá','David','Colón','La Chorrera'],
  CR:['San José','Alajuela','Cartago','Heredia'],
  CO:['Bogotá','Medellín','Cali','Barranquilla'],
  MX:['Ciudad de México','Guadalajara','Monterrey','Puebla'],
  PE:['Lima','Arequipa','Trujillo','Cusco'],
  AR:['Buenos Aires','Córdoba','Rosario','Mendoza'],
  BO:['La Paz','Santa Cruz de la Sierra','Cochabamba','Sucre'],
  CL:['Santiago','Valparaíso','Concepción','Antofagasta'],
  EC:['Quito','Guayaquil','Cuenca','Manta'],
  SV:['San Salvador','Santa Tecla','Santa Ana','San Miguel'],
  GT:['Ciudad de Guatemala','Quetzaltenango','Antigua Guatemala','Escuintla'],
  HN:['Tegucigalpa','San Pedro Sula','La Ceiba','Choluteca'],
  NI:['Managua','León','Granada','Matagalpa'],
  PY:['Asunción','San Lorenzo','Ciudad del Este','Encarnación'],
  PR:['San Juan','Bayamón','Ponce','Mayagüez'],
  UY:['Montevideo','Canelones','Maldonado','Salto'],
  VE:['Caracas','Maracaibo','Valencia','Barquisimeto'],
  BR:['São Paulo','Rio de Janeiro','Brasília','Belo Horizonte'],
};

export const getMarketSeo=(country=getCountry())=>{
  const cities=MARKET_CITIES[country.code]||[];
  if(country.code==='BR')return {
    cities,
    homeTitle:'Vagas de emprego no Brasil | Trabalhos | TalentosRD',
    homeDescription:`Encontre vagas de emprego no Brasil. Oportunidades atualizadas em ${cities.join(', ')} e outras cidades.`,
    homeH1:'Encontre as melhores vagas de emprego no Brasil',
  };
  return {
    cities,
    homeTitle:country.code==='DO'?'Empleos RD | Trabajos en República Dominicana | TalentosRD':`Empleos en ${country.name} | Trabajos y vacantes | TalentosRD`,
    homeDescription:`Encuentra empleos y trabajos en ${country.name}. Ofertas actualizadas en ${cities.join(', ')} y otras ciudades del país.`,
    homeH1:`Encuentra los mejores empleos y trabajos en ${country.name}`,
  };
};

export default function PageSeo({title,description,path='',canonical:canonicalOverride,noindex=false,alternates=false,structuredData}){
  const country=getCountry();
  const canonical=canonicalOverride||`https://talentosrd.com/${country.slug}${path}`;
  return <Helmet>
    <html lang={country.locale}/>
    <title>{title}</title>
    <meta name="description" content={description}/>
    <meta property="og:title" content={title}/>
    <meta property="og:description" content={description}/>
    <meta property="og:type" content="website"/>
    <meta property="og:url" content={canonical}/>
    <meta property="og:locale" content={country.locale.replace('-','_')}/>
    <link rel="canonical" href={canonical}/>
    {noindex&&<meta name="robots" content="noindex,nofollow"/>}
    {alternates&&Object.values(COUNTRIES).filter(item=>item.active).map(item=><link key={item.code} rel="alternate" hrefLang={item.locale} href={`https://talentosrd.com/${item.slug}${path}`}/>)}
    {alternates&&<link rel="alternate" hrefLang="x-default" href={`https://talentosrd.com/do${path}`}/>} 
    {structuredData&&<script type="application/ld+json">{JSON.stringify(structuredData)}</script>}
  </Helmet>;
}
